import React from 'react';
import { observer } from 'mobx-react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import withRouter from 'src/components/withRouter';

import styles from './styles.module.scss';

@observer
class SectionTabs extends React.Component {

  componentDidMount() {
    this.props.viewModel.didMount(this.props.router);
  }

  render() {
    const { viewModel, router } = this.props;
    return (
      <div className={clsx('secTabs', styles.sectionTabs, styles.sectionTabs_layout)}>
        <div className={clsx(styles.innerContainer, styles.innerContainer_layout)}>
          <div className={clsx(styles.tabFlex, styles.tabFlex_layout)}>
            {
              viewModel.sectionList?.map((section, index) => {
                return (
                  <NavLink
                    key={section}
                    to={`/course/${router.params.cid}/${section}`}
                    className={clsx(styles.tabFlex_item)}
                    onClick={() => viewModel.onSectionChange(section)}
                  >
                    {
                      ({ isActive }) => isActive
                        ? (
                          <div
                            className={clsx(styles.tabContainerActive, styles.tabContainer_layout)}
                          >
                            <h3 className={clsx(styles.tabTitleActive)}>
                              {viewModel.sectionName[index]}
                            </h3>
                          </div>
                        )
                        : (
                          <div
                            className={clsx(styles.tabContainer, styles.tabContainer_layout)}
                          >
                            <h3 className={clsx(styles.tabTitle)}>
                              {viewModel.sectionName[index]}
                            </h3>
                          </div>
                        )
                    }
                  </NavLink>
                );
              })
            }
          </div>
        </div>
      </div>
    );
  }
}

SectionTabs.propTypes = {
  viewModel: PropTypes.object,
  router: PropTypes.object
};

SectionTabs.defaultProps = {
  viewModel: {},
  router: {}
};

export default withRouter(SectionTabs);
